import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  fr: {
    // Login
    "login.title": "Portail propriétaires",
    "login.subtitle": "Saisissez vos séjours, options linge et demandes — sans emails, avec contrôles anti-erreurs.",
    "login.pill1": "J-7 verrouillage",
    "login.pill2": "Demandes & validations",
    "login.pill3": "Listing opérationnel",
    "login.card_title": "Connexion",
    "login.email": "Email",
    "login.password": "Mot de passe",
    "login.submit": "Se connecter",
    "login.loading": "Connexion…",
    "login.need_access": "Besoin d'un accès ? Contactez Blanc des Montagnes.",
    "login.forgot": "Mot de passe oublié ?",
    "login.tried_access": "Vous essayiez d'accéder à :",
    "login.success": "Connexion réussie",
    "login.success_desc": "Bienvenue sur le portail.",
    "login.error": "Connexion impossible",
    "login.error_desc": "Vérifiez vos identifiants",

    // Forgot password
    "forgot.title": "Mot de passe oublié",
    "forgot.subtitle": "Entrez votre email pour recevoir un lien de réinitialisation.",
    "forgot.email": "Adresse email",
    "forgot.submit": "Envoyer le lien",
    "forgot.loading": "Envoi…",
    "forgot.back": "Retour à la connexion",
    "forgot.success": "Email envoyé",
    "forgot.success_desc": "Si l'adresse existe, un email a été envoyé avec le lien de réinitialisation.",
    "forgot.error": "Erreur",

    // Reset password
    "reset.title": "Réinitialiser le mot de passe",
    "reset.subtitle": "Choisissez un nouveau mot de passe sécurisé (8 caractères minimum).",
    "reset.new_password": "Nouveau mot de passe",
    "reset.confirm": "Confirmer le mot de passe",
    "reset.submit": "Réinitialiser",
    "reset.loading": "Réinitialisation…",
    "reset.back": "Retour à la connexion",
    "reset.no_token": "Lien invalide ou expiré. Demandez un nouveau lien de réinitialisation.",
    "reset.mismatch": "Les mots de passe ne correspondent pas.",
    "reset.too_short": "Le mot de passe doit contenir au moins 8 caractères.",
    "reset.success": "Mot de passe modifié",
    "reset.success_desc": "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    "reset.error": "Erreur",

    // Layout
    "layout.admin": "Admin",
    "layout.owner": "Propriétaire",
    "layout.logout": "Déconnexion",
    "layout.disconnected": "Déconnecté",

    // Owner tabs
    "owner.tab.planning": "Planning",
    "owner.tab.account": "Mon compte",
    "owner.tab.invoices": "Factures",
    "owner.tab.stats": "Statistiques",
    "owner.tab.supplements": "Supplément",
    "owner.title": "Espace propriétaire",

    // Owner planning
    "owner.properties.title": "Vos logements",
    "owner.properties.subtitle": "Sélectionnez un logement pour voir et ajouter des séjours.",
    "owner.view.list": "Liste",
    "owner.view.calendar": "Calendrier",
    "owner.import_excel": "Import Excel",
    "owner.new_stay": "Nouveau séjour",
    "owner.property_select": "Logement sélectionné",
    "owner.property_choose": "Choisir un logement…",
    "owner.stays_shown": "Séjours affichés",
    "owner.no_stays": "Aucun séjour pour la période.",

    // Stay types & status
    "stay.tenant": "Locataire",
    "stay.owner": "Propriétaire",
    "stay.locked": "Verrouillé (J-7)",
    "stay.editable": "Modifiable",
    "stay.edit": "Modifier",
    "stay.delete": "Supprimer",
    "stay.duplicate": "Dupliquer",
    "stay.request": "Demande",
    "stay.delete_confirm": "Supprimer ce séjour ? Cette action est irréversible.",
    "stay.deleted": "Séjour supprimé",
    "stay.delete_error": "Suppression impossible",

    // Stay form
    "stay.form.new_title": "Nouveau séjour",
    "stay.form.edit_title": "Modifier le séjour",
    "stay.form.edit_desc": "Modifiez les informations du séjour. Les modifications sont possibles jusqu'à J-7 avant l'arrivée.",
    "stay.form.type": "Type",
    "stay.form.type_tenant": "Séjour locataire",
    "stay.form.type_owner": "Séjour propriétaire",
    "stay.form.dates": "Dates",
    "stay.form.arrival": "Arrivée",
    "stay.form.departure": "Départ",
    "stay.form.tenant_label": "Locataire (base recontact)",
    "stay.form.tenant_name": "Nom du locataire",
    "stay.form.phone": "Téléphone",
    "stay.form.email": "Email",
    "stay.form.nationality": "Nationalité",
    "stay.form.nationality_select": "Sélectionner...",
    "stay.form.people": "Nb personnes",
    "stay.form.services": "Prestations",
    "stay.form.cleaning": "Ménage",
    "stay.form.cleaning_mandatory": "(obligatoire)",
    "stay.form.self_clean": "Je fais le ménage moi-même",
    "stay.form.kits_simple": "Kits simples",
    "stay.form.kits_double": "Kits doubles",
    "stay.form.beds_simple": "Lits faits simples",
    "stay.form.beds_double": "Lits faits doubles",
    "stay.form.hygiene": "Kit hygiène",
    "stay.form.basket": "Panier d'accueil",
    "stay.form.basket_none": "Aucun",
    "stay.form.basket_standard": "Standard",
    "stay.form.basket_premium": "Premium",
    "stay.form.notes": "Note planning (1 ligne)",
    "stay.form.notes_placeholder": "Ex: Arrivée tardive possible, attention clé…",
    "stay.form.hint": "Rappel : lits faits impossible si kits linge = 0.",
    "stay.form.cancel": "Annuler",
    "stay.form.add": "Ajouter",
    "stay.form.save": "Enregistrer",
    "stay.form.created": "Séjour créé",
    "stay.form.created_desc": "Le séjour a été ajouté au planning.",
    "stay.form.modified": "Séjour modifié",
    "stay.form.modified_desc": "Les modifications ont été enregistrées.",

    // Stay form - edit specific
    "stay.form.edit_type": "Type de séjour",
    "stay.form.edit_arrival": "Date d'arrivée",
    "stay.form.edit_departure": "Date de départ",
    "stay.form.tenant_info": "Informations locataire",
    "stay.form.service_options": "Options de service",
    "stay.form.kit_simple": "Kit simple",
    "stay.form.kit_double": "Kit double",
    "stay.form.bed_simple": "Lit simple à faire",
    "stay.form.bed_double": "Lit double à faire",
    "stay.form.no_kits_warning": "Lits faits impossibles si aucun kit linge",
    "stay.form.hygiene_yes": "Oui",
    "stay.form.hygiene_no": "Non",
    "stay.form.basket_standard_detail": "Standard (3 produits)",
    "stay.form.basket_premium_detail": "Premium (6 produits)",
    "stay.form.notes_planning": "Notes planning",
    "stay.form.travelers": "Nb voyageurs",

    // Duplicate
    "stay.duplicated": "Séjour dupliqué",
    "stay.duplicated_desc": "Prestations copiées. Renseignez les dates et le locataire.",

    // Validation
    "val.choose_property": "Choisissez un logement",
    "val.choose_property_desc": "Sélectionnez un logement avant de créer un séjour.",
    "val.dates_missing": "Dates manquantes",
    "val.dates_missing_desc": "Renseignez une date d'arrivée et une date de départ.",
    "val.dates_invalid": "Dates invalides",
    "val.tenant_name_required": "Nom locataire obligatoire",
    "val.tenant_name_desc": "Veuillez renseigner le nom du locataire.",
    "val.tenant_email_required": "Email locataire obligatoire",
    "val.tenant_email_desc": "Veuillez renseigner l'email du locataire.",
    "val.nationality_required": "Nationalité obligatoire",
    "val.nationality_desc": "Veuillez renseigner la nationalité du locataire.",
    "val.beds_simple_invalid": "Lits simples invalides",
    "val.beds_double_invalid": "Lits doubles invalides",
    "val.creation_error": "Création impossible",
    "val.modification_error": "Modification impossible",

    // Import Excel
    "import.title": "Importer des séjours",
    "import.step1": "1. Télécharger le modèle",
    "import.step1_desc": "Fichier Excel pré-rempli avec vos logements et menus déroulants",
    "import.template": "Modèle",
    "import.template_downloaded": "Modèle téléchargé",
    "import.template_desc": "Remplissez le fichier Excel puis importez-le.",
    "import.how_to": "Comment remplir le fichier Excel ?",
    "import.guide": "Guide de saisie :",
    "import.step2": "2. Importer le fichier rempli",
    "import.close": "Fermer",
    "import.submit": "Importer",
    "import.success": "Import réussi",
    "import.error": "Import échoué",
    "import.impossible": "Import impossible",
    "import.download_error": "Téléchargement impossible",

    // Account
    "account.info_title": "Informations personnelles",
    "account.info_subtitle": "Modifiez vos coordonnées. L'email de connexion ne peut pas être changé ici.",
    "account.first_name": "Prénom",
    "account.last_name": "Nom",
    "account.phone": "Téléphone",
    "account.email_readonly": "Email (non modifiable)",
    "account.billing_address": "Adresse de facturation",
    "account.save": "Enregistrer les modifications",
    "account.saved": "Compte mis à jour",
    "account.saved_desc": "Vos informations ont été enregistrées.",
    "account.save_error": "Mise à jour impossible",

    // Password
    "password.title": "Changer le mot de passe",
    "password.subtitle": "Votre nouveau mot de passe doit contenir au moins 8 caractères.",
    "password.current": "Mot de passe actuel",
    "password.new": "Nouveau mot de passe",
    "password.confirm": "Confirmer le nouveau mot de passe",
    "password.submit": "Changer le mot de passe",
    "password.changed": "Mot de passe modifié",
    "password.changed_desc": "Votre mot de passe a été changé.",
    "password.mismatch": "Les mots de passe ne correspondent pas.",
    "password.too_short": "Le nouveau mot de passe doit contenir au moins 8 caractères.",
    "password.error": "Changement impossible",

    // Marketing consent
    "marketing.title": "Communication voyageurs (RGPD)",
    "marketing.subtitle": "Autorisez l'envoi d'emails de services aux voyageurs (location ski, transferts).",
    "marketing.consent_text": "J'accepte que Blanc des Montagnes envoie un email informatif unique aux voyageurs de mes séjours",
    "marketing.consent_detail": "Cet email présente des services utiles (location ski, transferts) adaptés à la saison. Aucune newsletter, aucune relance. Un seul email par séjour, uniquement si le voyageur a fourni son email.",
    "marketing.consent_on": "Consentement activé",
    "marketing.consent_on_desc": "Vous pourrez envoyer des emails de services aux voyageurs.",
    "marketing.consent_off": "Consentement désactivé",
    "marketing.consent_off_desc": "Les emails de services ne seront plus envoyés aux voyageurs.",
    "marketing.consent_date": "Consentement donné le",
    "marketing.no_consent": "Sans ce consentement, aucun email ne sera envoyé aux voyageurs de vos séjours.",
    "marketing.rgpd_title": "Conformité RGPD :",
    "marketing.rgpd_1": "Chaque email inclut une mention explicative et un lien de désinscription",
    "marketing.rgpd_2": "Les données voyageurs sont utilisées uniquement pour ce service",
    "marketing.rgpd_3": "Vous pouvez retirer ce consentement à tout moment",

    // Invoices
    "invoices.title": "Mes factures",
    "invoices.subtitle": "Consultez et téléchargez vos factures PDF.",
    "invoices.number": "N° Facture",
    "invoices.period": "Période",
    "invoices.amount": "Montant TTC",
    "invoices.status": "Statut",
    "invoices.actions": "Actions",
    "invoices.paid": "Soldée",
    "invoices.unpaid": "Non soldée",
    "invoices.download": "Télécharger",
    "invoices.empty": "Aucune facture disponible.",
    "invoices.download_error": "Téléchargement impossible",

    // Statistics
    "stats.title": "Mes statistiques",
    "stats.subtitle": "Vue d'ensemble de vos réservations sur la période sélectionnée.",
    "stats.from": "Date début",
    "stats.to": "Date fin",
    "stats.property": "Logement",
    "stats.all_properties": "Tous mes logements",
    "stats.refresh": "Actualiser",
    "stats.loading": "Chargement...",
    "stats.stays": "Séjours",
    "stats.nights": "Nuitées",
    "stats.cleanings": "Ménages",
    "stats.linen_kits": "Kits linge",
    "stats.beds_made": "Lits faits",
    "stats.cleaning_progress": "Progression ménages",
    "stats.cleaning_objective": "Objectif minimum : 5 interventions ménage par logement",
    "stats.no_property": "Aucun logement trouvé",
    "stats.billing": "Facturation",
    "stats.total_billed": "Total facturé",
    "stats.total_paid": "Payé",
    "stats.total_pending": "En attente",
    "stats.by_month": "Par mois",
    "stats.month": "Mois",

    // Supplements
    "supplements.title": "Supplément",
    "supplements.subtitle": "Surcoûts ménage et interventions techniques",
    "supplements.surcharges": "Surcoûts ménage",
    "supplements.no_surcharges": "Aucun surcoût enregistré",
    "supplements.interventions": "Interventions techniques",
    "supplements.no_interventions": "Aucune intervention enregistrée",
    "supplements.intervention_date": "Intervention du",

    // CGP
    "cgp.title": "Conditions Générales de Prestation",
    "cgp.subtitle": "Veuillez lire et accepter les Conditions Générales de Prestation pour accéder à votre espace propriétaire.",
    "cgp.accept_note": "En cliquant sur \"J'accepte\", vous confirmez avoir lu et accepté les présentes conditions, y compris la clause RGPD autorisant la communication avec vos voyageurs.",
    "cgp.accept": "J'accepte les CGP",
    "cgp.accepting": "Acceptation...",
    "cgp.welcome": "Bienvenue !",
    "cgp.welcome_desc": "Merci d'avoir accepté les Conditions Générales de Prestation.",
    "cgp.error": "Impossible d'accepter les CGP. Veuillez réessayer.",

    // Request dialog
    "request.title": "Créer une demande",
    "request.stay_info": "Séjour",
    "request.j7_note": "Après J-7, l'annulation/modification passe obligatoirement par une demande.",
    "request.type_label": "Type de demande",
    "request.early_arrival": "Arrivée anticipée",
    "request.late_departure": "Départ tardif",
    "request.modify": "Modification (après verrouillage)",
    "request.cancel": "Annulation (après verrouillage)",
    "request.time_label": "Heure demandée",
    "request.time_hint": "Le prix par défaut est 25€ TTC.",
    "request.modify_help": "Modification des prestations + note planning.",
    "request.cancel_warning": "Annulation demandée. L'équipe doit valider.",
    "request.close": "Fermer",
    "request.submit": "Envoyer",
    "request.sent": "Demande envoyée",
    "request.sent_desc": "Elle sera traitée par l'équipe.",

    // Nationalities
    "nat.FR": "France",
    "nat.UK": "Royaume-Uni",
    "nat.BE": "Belgique",
    "nat.CH": "Suisse",
    "nat.ES": "Espagne",
    "nat.NL": "Pays-Bas",
    "nat.IT": "Italie",
    "nat.DE": "Allemagne",
    "nat.Other": "Autre",

    // Table headers
    "table.dates": "Dates",
    "table.type": "Type",
    "table.options": "Options",
    "table.status": "Statut",
    "table.actions": "Actions",

    // Common
    "common.error": "Erreur",
    "common.loading": "Chargement…",
  },

  en: {
    // Login
    "login.title": "Owner Portal",
    "login.subtitle": "Enter your stays, linen options and requests — no emails, with error prevention.",
    "login.pill1": "D-7 lock",
    "login.pill2": "Requests & approvals",
    "login.pill3": "Operations listing",
    "login.card_title": "Login",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.loading": "Signing in…",
    "login.need_access": "Need access? Contact Blanc des Montagnes.",
    "login.forgot": "Forgot password?",
    "login.tried_access": "You were trying to access:",
    "login.success": "Login successful",
    "login.success_desc": "Welcome to the portal.",
    "login.error": "Login failed",
    "login.error_desc": "Please check your credentials",

    // Forgot password
    "forgot.title": "Forgot password",
    "forgot.subtitle": "Enter your email to receive a reset link.",
    "forgot.email": "Email address",
    "forgot.submit": "Send reset link",
    "forgot.loading": "Sending…",
    "forgot.back": "Back to login",
    "forgot.success": "Email sent",
    "forgot.success_desc": "If the address exists, an email has been sent with the reset link.",
    "forgot.error": "Error",

    // Reset password
    "reset.title": "Reset password",
    "reset.subtitle": "Choose a new secure password (minimum 6 characters).",
    "reset.new_password": "New password",
    "reset.confirm": "Confirm password",
    "reset.submit": "Reset",
    "reset.loading": "Resetting…",
    "reset.back": "Back to login",
    "reset.no_token": "Invalid or expired link. Please request a new reset link.",
    "reset.mismatch": "Passwords do not match.",
    "reset.too_short": "Password must be at least 6 characters.",
    "reset.success": "Password changed",
    "reset.success_desc": "You can now sign in with your new password.",
    "reset.error": "Error",

    // Layout
    "layout.admin": "Admin",
    "layout.owner": "Owner",
    "layout.logout": "Logout",
    "layout.disconnected": "Logged out",

    // Owner tabs
    "owner.tab.planning": "Planning",
    "owner.tab.account": "My account",
    "owner.tab.invoices": "Invoices",
    "owner.tab.stats": "Statistics",
    "owner.tab.supplements": "Supplements",
    "owner.title": "Owner Portal",

    // Owner planning
    "owner.properties.title": "Your properties",
    "owner.properties.subtitle": "Select a property to view and add stays.",
    "owner.view.list": "List",
    "owner.view.calendar": "Calendar",
    "owner.import_excel": "Import Excel",
    "owner.new_stay": "New stay",
    "owner.property_select": "Selected property",
    "owner.property_choose": "Choose a property…",
    "owner.stays_shown": "Stays shown",
    "owner.no_stays": "No stays for this period.",

    // Stay types & status
    "stay.tenant": "Tenant",
    "stay.owner": "Owner",
    "stay.locked": "Locked (D-7)",
    "stay.editable": "Editable",
    "stay.edit": "Edit",
    "stay.delete": "Delete",
    "stay.duplicate": "Duplicate",
    "stay.request": "Request",
    "stay.delete_confirm": "Delete this stay? This action is irreversible.",
    "stay.deleted": "Stay deleted",
    "stay.delete_error": "Cannot delete",

    // Stay form
    "stay.form.new_title": "New stay",
    "stay.form.edit_title": "Edit stay",
    "stay.form.edit_desc": "Edit stay details. Changes are possible up to D-7 before arrival.",
    "stay.form.type": "Type",
    "stay.form.type_tenant": "Tenant stay",
    "stay.form.type_owner": "Owner stay",
    "stay.form.dates": "Dates",
    "stay.form.arrival": "Check-in",
    "stay.form.departure": "Check-out",
    "stay.form.tenant_label": "Tenant (for future contact)",
    "stay.form.tenant_name": "Tenant name",
    "stay.form.phone": "Phone",
    "stay.form.email": "Email",
    "stay.form.nationality": "Nationality",
    "stay.form.nationality_select": "Select...",
    "stay.form.people": "Guests",
    "stay.form.services": "Services",
    "stay.form.cleaning": "Cleaning",
    "stay.form.cleaning_mandatory": "(mandatory)",
    "stay.form.self_clean": "I'll clean myself",
    "stay.form.kits_simple": "Single kits",
    "stay.form.kits_double": "Double kits",
    "stay.form.beds_simple": "Single beds made",
    "stay.form.beds_double": "Double beds made",
    "stay.form.hygiene": "Hygiene kit",
    "stay.form.basket": "Welcome basket",
    "stay.form.basket_none": "None",
    "stay.form.basket_standard": "Standard",
    "stay.form.basket_premium": "Premium",
    "stay.form.notes": "Planning note (1 line)",
    "stay.form.notes_placeholder": "E.g.: Late arrival possible, attention key…",
    "stay.form.hint": "Reminder: beds made is not possible if linen kits = 0.",
    "stay.form.cancel": "Cancel",
    "stay.form.add": "Add",
    "stay.form.save": "Save",
    "stay.form.created": "Stay created",
    "stay.form.created_desc": "The stay has been added to the planning.",
    "stay.form.modified": "Stay modified",
    "stay.form.modified_desc": "Changes have been saved.",

    // Stay form - edit specific
    "stay.form.edit_type": "Stay type",
    "stay.form.edit_arrival": "Check-in date",
    "stay.form.edit_departure": "Check-out date",
    "stay.form.tenant_info": "Tenant information",
    "stay.form.service_options": "Service options",
    "stay.form.kit_simple": "Single kit",
    "stay.form.kit_double": "Double kit",
    "stay.form.bed_simple": "Single bed to make",
    "stay.form.bed_double": "Double bed to make",
    "stay.form.no_kits_warning": "Beds cannot be made without linen kits",
    "stay.form.hygiene_yes": "Yes",
    "stay.form.hygiene_no": "No",
    "stay.form.basket_standard_detail": "Standard (3 items)",
    "stay.form.basket_premium_detail": "Premium (6 items)",
    "stay.form.notes_planning": "Planning notes",
    "stay.form.travelers": "Travelers",

    // Duplicate
    "stay.duplicated": "Stay duplicated",
    "stay.duplicated_desc": "Services copied. Please enter dates and tenant details.",

    // Validation
    "val.choose_property": "Choose a property",
    "val.choose_property_desc": "Select a property before creating a stay.",
    "val.dates_missing": "Missing dates",
    "val.dates_missing_desc": "Enter a check-in and check-out date.",
    "val.dates_invalid": "Invalid dates",
    "val.tenant_name_required": "Tenant name required",
    "val.tenant_name_desc": "Please enter the tenant's name.",
    "val.tenant_email_required": "Tenant email required",
    "val.tenant_email_desc": "Please enter the tenant's email.",
    "val.nationality_required": "Nationality required",
    "val.nationality_desc": "Please enter the tenant's nationality.",
    "val.beds_simple_invalid": "Invalid single beds",
    "val.beds_double_invalid": "Invalid double beds",
    "val.creation_error": "Cannot create",
    "val.modification_error": "Cannot modify",

    // Import Excel
    "import.title": "Import stays",
    "import.step1": "1. Download template",
    "import.step1_desc": "Pre-filled Excel file with your properties and dropdown menus",
    "import.template": "Template",
    "import.template_downloaded": "Template downloaded",
    "import.template_desc": "Fill in the Excel file then import it.",
    "import.how_to": "How to fill the Excel file?",
    "import.guide": "Input guide:",
    "import.step2": "2. Upload filled file",
    "import.close": "Close",
    "import.submit": "Import",
    "import.success": "Import successful",
    "import.error": "Import failed",
    "import.impossible": "Cannot import",
    "import.download_error": "Download failed",

    // Account
    "account.info_title": "Personal information",
    "account.info_subtitle": "Update your details. The login email cannot be changed here.",
    "account.first_name": "First name",
    "account.last_name": "Last name",
    "account.phone": "Phone",
    "account.email_readonly": "Email (read-only)",
    "account.billing_address": "Billing address",
    "account.save": "Save changes",
    "account.saved": "Account updated",
    "account.saved_desc": "Your information has been saved.",
    "account.save_error": "Update failed",

    // Password
    "password.title": "Change password",
    "password.subtitle": "Your new password must be at least 6 characters.",
    "password.current": "Current password",
    "password.new": "New password",
    "password.confirm": "Confirm new password",
    "password.submit": "Change password",
    "password.changed": "Password changed",
    "password.changed_desc": "Your password has been updated.",
    "password.mismatch": "Passwords do not match.",
    "password.too_short": "New password must be at least 6 characters.",
    "password.error": "Cannot change",

    // Marketing consent
    "marketing.title": "Traveler communications (GDPR)",
    "marketing.subtitle": "Authorize sending service emails to travelers (ski rental, transfers).",
    "marketing.consent_text": "I agree that Blanc des Montagnes sends a single informational email to travelers of my stays",
    "marketing.consent_detail": "This email presents useful services (ski rental, transfers) adapted to the season. No newsletter, no follow-ups. One email per stay, only if the traveler provided their email.",
    "marketing.consent_on": "Consent enabled",
    "marketing.consent_on_desc": "Service emails will be sent to travelers.",
    "marketing.consent_off": "Consent disabled",
    "marketing.consent_off_desc": "Service emails will no longer be sent to travelers.",
    "marketing.consent_date": "Consent given on",
    "marketing.no_consent": "Without consent, no emails will be sent to your travelers.",
    "marketing.rgpd_title": "GDPR Compliance:",
    "marketing.rgpd_1": "Each email includes an explanatory note and an unsubscribe link",
    "marketing.rgpd_2": "Traveler data is used only for this service",
    "marketing.rgpd_3": "You can withdraw consent at any time",

    // Invoices
    "invoices.title": "My invoices",
    "invoices.subtitle": "View and download your PDF invoices.",
    "invoices.number": "Invoice #",
    "invoices.period": "Period",
    "invoices.amount": "Amount (incl. tax)",
    "invoices.status": "Status",
    "invoices.actions": "Actions",
    "invoices.paid": "Paid",
    "invoices.unpaid": "Unpaid",
    "invoices.download": "Download",
    "invoices.empty": "No invoices available.",
    "invoices.download_error": "Download failed",

    // Statistics
    "stats.title": "My statistics",
    "stats.subtitle": "Overview of your bookings for the selected period.",
    "stats.from": "Start date",
    "stats.to": "End date",
    "stats.property": "Property",
    "stats.all_properties": "All my properties",
    "stats.refresh": "Refresh",
    "stats.loading": "Loading...",
    "stats.stays": "Stays",
    "stats.nights": "Nights",
    "stats.cleanings": "Cleanings",
    "stats.linen_kits": "Linen kits",
    "stats.beds_made": "Beds made",
    "stats.cleaning_progress": "Cleaning progress",
    "stats.cleaning_objective": "Minimum goal: 5 cleaning interventions per property",
    "stats.no_property": "No property found",
    "stats.billing": "Billing",
    "stats.total_billed": "Total billed",
    "stats.total_paid": "Paid",
    "stats.total_pending": "Pending",
    "stats.by_month": "By month",
    "stats.month": "Month",

    // Supplements
    "supplements.title": "Supplements",
    "supplements.subtitle": "Cleaning surcharges and technical interventions",
    "supplements.surcharges": "Cleaning surcharges",
    "supplements.no_surcharges": "No surcharges recorded",
    "supplements.interventions": "Technical interventions",
    "supplements.no_interventions": "No interventions recorded",
    "supplements.intervention_date": "Intervention on",

    // CGP
    "cgp.title": "General Terms of Service",
    "cgp.subtitle": "Please read and accept the General Terms of Service to access your owner portal.",
    "cgp.accept_note": "By clicking \"I accept\", you confirm that you have read and accepted these terms, including the GDPR clause authorizing communication with your travelers.",
    "cgp.accept": "I accept the Terms",
    "cgp.accepting": "Accepting...",
    "cgp.welcome": "Welcome!",
    "cgp.welcome_desc": "Thank you for accepting the General Terms of Service.",
    "cgp.error": "Cannot accept the Terms. Please try again.",

    // Request dialog
    "request.title": "Create a request",
    "request.stay_info": "Stay",
    "request.j7_note": "After D-7, cancellation/modification must go through a request.",
    "request.type_label": "Request type",
    "request.early_arrival": "Early check-in",
    "request.late_departure": "Late check-out",
    "request.modify": "Modification (after lock)",
    "request.cancel": "Cancellation (after lock)",
    "request.time_label": "Requested time",
    "request.time_hint": "Default price is €20 incl. tax.",
    "request.modify_help": "Modify services + planning note.",
    "request.cancel_warning": "Cancellation requested. The team must validate.",
    "request.close": "Close",
    "request.submit": "Send",
    "request.sent": "Request sent",
    "request.sent_desc": "It will be processed by the team.",

    // Nationalities
    "nat.FR": "France",
    "nat.UK": "United Kingdom",
    "nat.BE": "Belgium",
    "nat.CH": "Switzerland",
    "nat.ES": "Spain",
    "nat.NL": "Netherlands",
    "nat.IT": "Italy",
    "nat.DE": "Germany",
    "nat.Other": "Other",

    // Table headers
    "table.dates": "Dates",
    "table.type": "Type",
    "table.options": "Options",
    "table.status": "Status",
    "table.actions": "Actions",

    // Common
    "common.error": "Error",
    "common.loading": "Loading…",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("bdm_lang");
    if (saved === "en" || saved === "fr") return saved;
    const browserLang = navigator.language?.slice(0, 2);
    return browserLang === "en" ? "en" : "fr";
  });

  useEffect(() => {
    localStorage.setItem("bdm_lang", lang);
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.fr[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("LanguageContext missing");
  return ctx;
}
